import RadioList from 'components/forms/RadioList/RadioList';

export default RadioList;
